module.exports = __webpack_public_path__ + "static/media/bg-palm-creature-4.dc4bf33f.svg";